<template>
	<div class="wrap wrap_business">
		<div class="chart_box">
			<h2 class="report_title">주요사업</h2>
			<BusinessChartItemJPN :data="props.data.main_business.business" />
		</div>
		<div v-if="!(props.data.main_business.introduction === '<p></p>')" class="description_box">
			<h2 class="report_title">주요사업 소개</h2>
			<div
				v-dompurify-html="props.data.main_business.introduction"
				class="c_editorContent c_editorContent_outline"
			></div>
		</div>
		<div class="chart_box">
			<h2 class="report_title">주요 매출처</h2>
			<BusinessChartItemJPN :data="props.data.main_customer.customer" />
		</div>
		<div v-if="!(props.data.main_customer.introduction === '<p></p>')" class="description_box">
			<h2 class="report_title">주요 매출처 소개</h2>
			<div
				v-dompurify-html="props.data.main_customer.introduction"
				class="c_editorContent c_editorContent_outline"
			></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { InvestReportBusinessData } from '@/api/report';
import BusinessChartItemJPN from '@/components/report/jpn/BusinessChartItemJPN.vue';

const props = defineProps<{
	data: InvestReportBusinessData;
}>();
</script>

<style scoped lang="scss">
.wrap_business {
	.report_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-bold);
		line-height: 2.387rem;
	}
	.chart_box {
		display: flex;
		flex-direction: column;
		gap: 2.4rem;
	}
	.description_box {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
}
</style>
